import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectBankInfos, selectDDFormError, selectDDFormLoading, selectEmployerName, selectDDFormEntryPoint, selectFormUrl, selectIsEditFlow, selectSignatureStyle, selectUserName, setBankInfos, setEmployerName, setDDFormEntryPoint, setFormUrl, setIsEditFlow, setSignatureStyle, setUserName, } from '../state/slices/slice-dd-form';
export var useDDFormContext = function () {
    var dispatch = useDispatch();
    var employerName = useSelector(selectEmployerName);
    var userName = useSelector(selectUserName);
    var signatureStyle = useSelector(selectSignatureStyle);
    var isEditFlow = useSelector(selectIsEditFlow);
    var bankInfos = useSelector(selectBankInfos);
    var formUrl = useSelector(selectFormUrl);
    var error = useSelector(selectDDFormError);
    var loading = useSelector(selectDDFormLoading);
    var ddFormEntryPoint = useSelector(selectDDFormEntryPoint);
    var contextValue = React.useMemo(function () { return ({
        employerName: employerName,
        setEmployerName: function (newEmployerName) {
            return dispatch(setEmployerName(newEmployerName));
        },
        userName: userName,
        setUserName: function (newUserName) { return dispatch(setUserName(newUserName)); },
        signatureStyle: signatureStyle,
        setSignatureStyle: function (newSignatureStyle) {
            return dispatch(setSignatureStyle(newSignatureStyle));
        },
        isEditFlow: isEditFlow,
        setIsEditFlow: function (_isEditFlow) {
            return dispatch(setIsEditFlow(_isEditFlow));
        },
        bankInfos: bankInfos,
        setBankInfos: function (newBankInfos) {
            return dispatch(setBankInfos(newBankInfos));
        },
        formUrl: formUrl,
        setFormUrl: function (newFormUrl) { return dispatch(setFormUrl(newFormUrl)); },
        error: error,
        loading: loading,
        entryPoint: ddFormEntryPoint,
        setDDFormEntryPoint: function (newEntryPoint) {
            return dispatch(setDDFormEntryPoint(newEntryPoint));
        },
    }); }, [
        bankInfos,
        dispatch,
        employerName,
        error,
        formUrl,
        isEditFlow,
        loading,
        signatureStyle,
        userName,
        ddFormEntryPoint,
    ]);
    return contextValue;
};
